import { MimeType, ExportSubFunction, ExportCategory } from "../constants/constants-container";
import moment from "moment";

const defaultFileFormat = "xlsx";

class Exporter {
  constructor(http) {
    this.http = http;
    this.selectedBranchId = null;
    this.str_URL_BASE = this.http.get_str_URL_BASE;
  }

  setSelectedBranchId = (branchId) => {
    this.selectedBranchId = branchId;
  };

  constructUrl = (constructUrlParameters) => {
    const {
      selectedExportSubFunction,
      selectedFramework,
      selectedItems,
      selectedFrameworks,
      includeMappingContent,
      includeRenderingContent,
      includeTransformationContent,
      selectedCubes,
      selectedVariable,
      selectedCubeTypes,
      selectedCubeHierarchies,
      branchIdToOverrideWorkingBranchId,
      fileFormat,
      selectedRelease,
      onlyThisBranch,
    } = constructUrlParameters;

    let validOnDate = constructUrlParameters.validOnDate // not parsed JS Date, might be null 
    let onlyCurrentlyValidMetadata = constructUrlParameters.onlyCurrentlyValidMetadata

    let urlFormatPart = "";
    let urlEntityPart = "excel";

    switch (selectedExportSubFunction) {
      case ExportSubFunction.ENTITY_EXPORT:
        urlEntityPart = urlEntityPart + "?entities=";
        if(!selectedItems || selectedItems.length === 0) {
          urlEntityPart += "all"
        } else {
          for (let i = 0; i < selectedItems.length; i++) {
            const item = selectedItems[i];
            urlEntityPart += "sdd" + item.toLowerCase() + (i !== selectedItems.length - 1 ? "," : "");
          }
        }
        urlEntityPart += "&"
        break;
      case ExportSubFunction.FRAMEWORKS_EXPORT:
        urlEntityPart = urlEntityPart + "/tree?";
        for (let id of selectedFrameworks) {
          urlEntityPart = urlEntityPart + "treeRootIds=" + id + "&";
        }
        urlEntityPart =
          urlEntityPart +
          "treeRootType=FRAMEWORK&includeMappingContent=" +
          includeMappingContent +
          "&includeRenderingContent=" +
          includeRenderingContent +
          "&includeTransformationContent=" +
          includeTransformationContent +
          "&";
        break;
      case ExportSubFunction.INDIVIDUAL_CUBE_EXPORT:
        urlEntityPart = urlEntityPart + "/tree?";
        if (selectedCubes.length > 0) {
          for (let i = 0; i < selectedCubes.length; i++) {
            urlEntityPart =
              urlEntityPart + "treeRootIds=" + selectedCubes[i] + "&";
          }
        } else {
          for (let i = 0; i < selectedCubeTypes.length; i++) {
            urlEntityPart =
              urlEntityPart + "cubeTypes=" + selectedCubeTypes[i] + "&";
          }
        }
        urlEntityPart =
          urlEntityPart +
          "frameworkIdOfCubes=" +
          selectedFramework +
          "&treeRootType=CUBE&";
        break;
      case ExportSubFunction.INDIVIDUAL_CUBE_VIEW_EXPORT:
        urlEntityPart = urlEntityPart + "/tree?";
        urlEntityPart =
          urlEntityPart + "treeRootIds=" + selectedCubes.cubeId + "&";
        urlEntityPart =
          urlEntityPart +
          "frameworkIdOfCubes=" +
          selectedFramework +
          "&treeRootType=CUBE&";
        break;
      case ExportSubFunction.INDIVIDUAL_VARIABLE_EXPORT:
        urlEntityPart = urlEntityPart + "/tree?";
        urlEntityPart =
          urlEntityPart +
          "treeRootIds=" +
          encodeURIComponent(selectedCubes.cubeId) +
          "&";
        urlEntityPart =
          urlEntityPart +
          "variableId=" +
          encodeURIComponent(selectedVariable.variableId) +
          "&frameworkIdOfCubes=" +
          selectedFramework +
          "&treeRootType=CUBE&";
        break;
      case ExportSubFunction.INDIVIDUAL_VARIABLE_MEMBERS_EXPORT:
        urlEntityPart = urlEntityPart + "/tree?";
        urlEntityPart = urlEntityPart + "format=xlsx&";
        urlEntityPart =
          urlEntityPart +
          "variableId=" +
          selectedVariable.variableId +
          "&treeRootType=VARIABLE&";
        break;
      case ExportSubFunction.FRAMEWORK_MATRIX_EXPORT:
        // selectedCubeHierarchies array has always one element
        urlEntityPart =
          urlEntityPart +
          "/tree?treeRootIds=" +
          selectedCubeHierarchies[0] +
          "&treeRootType=CUBEHIERARCHY&";
        break;
      case ExportSubFunction.FRAMEWORK_LOGICAL_LINEAGE:
        urlEntityPart = urlEntityPart + "/framework-logical-lineage?";
        for (let id of selectedFrameworks) {
          urlEntityPart = urlEntityPart + "frameworkIds=" + id + "&";
        }
        break;
      case ExportSubFunction.FRAMEWORK_MODELS_OVERVIEW:
        urlEntityPart += "/framework-models-overview?frameworkId=" + selectedFramework + "&"
        break;
      default:
        break;
    }

    // branch
    if (branchIdToOverrideWorkingBranchId) {
      urlEntityPart =
        urlEntityPart + "branch=" + branchIdToOverrideWorkingBranchId + "&";
    } else if (selectedRelease && selectedRelease.branchTid !== 1) {
      urlEntityPart = urlEntityPart + "onlyThisBranch=true&branch=" + selectedRelease.branchTid + "&";
    }
     else if (this.selectedBranchId !== null) {
      urlEntityPart = urlEntityPart + "branch=" + this.selectedBranchId + "&";
    }

    if (onlyThisBranch && !urlEntityPart.includes("onlyThisBranch")) {
      urlEntityPart = urlEntityPart + "onlyThisBranch=true&";
    }

    // set today as default if not set
    if (ExportCategory.SIMPLIFIED.includes(selectedExportSubFunction) && !validOnDate) {
      validOnDate = new Date()
    }

    if (validOnDate) {
      onlyCurrentlyValidMetadata = true;

      const parsedDate = moment(validOnDate).format("YYYY-MM-DD")
      urlEntityPart += "validOn=" + parsedDate + "&";
    }

    // consider most recent versions
    if (
      selectedExportSubFunction === ExportSubFunction.FRAMEWORKS_EXPORT ||
      selectedExportSubFunction === ExportSubFunction.INDIVIDUAL_CUBE_EXPORT ||
      selectedExportSubFunction === ExportSubFunction.INDIVIDUAL_CUBE_VIEW_EXPORT ||
      selectedExportSubFunction === ExportSubFunction.INDIVIDUAL_VARIABLE_EXPORT ||
      selectedExportSubFunction === ExportSubFunction.FRAMEWORK_MATRIX_EXPORT ||
      selectedExportSubFunction === ExportSubFunction.ENTITY_EXPORT ||
      selectedExportSubFunction === ExportSubFunction.FRAMEWORK_LOGICAL_LINEAGE ||
      selectedExportSubFunction === ExportSubFunction.FRAMEWORK_MODELS_OVERVIEW
    ) {
      urlEntityPart += "onlyCurrentlyValidMetadata=" + onlyCurrentlyValidMetadata + "&";
    }

    // file format
    if (fileFormat === "xlsx") {
      urlFormatPart = "format=xlsx";
    } else if (fileFormat === "xls") {
      urlFormatPart = "format=xls";
    } else {
      urlFormatPart = "format=csv";
    }

    return this.str_URL_BASE + urlEntityPart + urlFormatPart;
  };

  generateFileName(prefix, extension) {
    return (
      prefix +
      "-" +
      new Date().toLocaleDateString() +
      "_" +
      new Date().toLocaleTimeString() +
      "." +
      extension
    );
  }

  getMimeType(fileFormat) {
    switch(fileFormat) {
      case "csv":
        return MimeType.CSV;
      case "xlsx":
        return MimeType.XLSX;
      case "zip":
        return MimeType.ZIP;
      default:
        return MimeType.XLS;
    }
  }

  sendExportRequest = (exportUrl, fileName, fileFormat) => {
    const mimeType = this.getMimeType(fileFormat);
    this.http.sendExportRequest(exportUrl, mimeType, fileName);
  };

  exportRelease = (release, frameworksNames) => {
    const releaseType =
      release.branchType === "FINAL" ? "final-release" : "intermediate-release";
    const fileName = this.generateFileName(
      frameworksNames + "-" + releaseType + "-" + release.name,
      defaultFileFormat
    );
    const url =
      this.str_URL_BASE +
      "excel?onlyThisBranch=true&entities=all&branch=" +
      release.tid;
    this.sendExportRequest(url, fileName, defaultFileFormat);
  };

  exportLatestProductionChangelog = (frameworks) => {
    const frameworksName = frameworks
      ? frameworks.map((framework) => framework.name).join("-")
      : "";
    const fileName = this.generateFileName(
      "production-changelog" + frameworksName,
      defaultFileFormat
    );
    const frameworkIds = frameworks
      ? frameworks.map((framework) => framework.frameworkId).join(",")
      : "";
    const frameworkIdParam = frameworks
      ? "?frameworkId=" + encodeURI(frameworkIds)
      : "";
    const url = this.str_URL_BASE + "history/excel" + frameworkIdParam;
    this.sendExportRequest(url, fileName, defaultFileFormat);
  };

  shortenSnapshotNameIfNeeded = (name) => {
    if (name.length > 10) {
      if (name.includes("Production")) {
        const snapshotNameArray = name.split(" ");
        return (
          snapshotNameArray[0].substring(0, 4) +
          ".." +
          snapshotNameArray[1].substring(0, 4)
        );
      } else {
        return (
          name.substring(0, 4) +
          ".." +
          name.substring(name.length - 4, name.length)
        );
      }
    } else {
      return name;
    }
  };

  compareFrameworks = (snapshotOne, snapshotTwo, comaSeperatedFrameworkIds) => {
    let snapshotOneUrlPart = "bidOne=" + snapshotOne.tid;
    let snapshotTwoUrlPart = "&bidTwo=" + snapshotTwo.tid;

    if (snapshotOne.date) {
      snapshotOneUrlPart += "&bidOneSnapshotDate=" + moment(snapshotOne.date).format("YYYY-MM-DD_HH:mm:ss")
    }

    if (snapshotTwo.date) {
      snapshotTwoUrlPart += "&bidTwoSnapshotDate=" + moment(snapshotTwo.date).format("YYYY-MM-DD_HH:mm:ss")
    }

    const frameworkIdParameter = comaSeperatedFrameworkIds
      ? "&frameworkIds=" + comaSeperatedFrameworkIds
      : "";
    const url =
      this.str_URL_BASE +
      "excel/framework/comparison?" +
      snapshotOneUrlPart +
      snapshotTwoUrlPart +
      frameworkIdParameter;
    const fileName = this.generateFileName(
      "comparison-" +
        this.shortenSnapshotNameIfNeeded(snapshotOne.name) +
        "-" +
        this.shortenSnapshotNameIfNeeded(snapshotTwo.name),
      defaultFileFormat
    );
    this.sendExportRequest(url, fileName, defaultFileFormat);
  };

  exportEntitiesByTid = (tids, entity) => {
    const fileName = this.generateFileName(
      "selected-entities",
      defaultFileFormat
    );
    let url = this.str_URL_BASE + "excel?entities=" + entity + "&";
    for (let i = 0; i < tids.length; i++) {
      url += "tids=" + tids[i] + "&";
    }
    url += "format=xlsx";
    this.sendExportRequest(url, fileName, defaultFileFormat);
  };

  exportMappingDefinitions = (tids) => {
    const fileName = this.generateFileName(
      "MappingDefinitions",
      defaultFileFormat
    );
    let url =
      this.str_URL_BASE +
      "excel/export/mappingdefinitions?entities=sddMappingDefinition&format=xlsx&tids=" +
      encodeURI(tids.join(","));
    this.sendExportRequest(url, fileName, defaultFileFormat);
  };

  export = (exportParameters) => {
    const {
      selectedExportSubFunction,
      selectedCubeHierarchies,
      selectedFramework,
      selectedVariable,
      selectedCubes,
      fileFormat,
      selectedFrameworks,
      selectedRelease,
    } = exportParameters;

    let exportUrl = "";
    const fileFormatForExport = this.figureOutFileFormat(fileFormat);
    if (
      selectedExportSubFunction === ExportSubFunction.FRAMEWORK_MATRIX_EXPORT
    ) {
      selectedCubeHierarchies.forEach((cubeHierarchy) => {
        const arrayWithSelectedCubeHierarchyId = [cubeHierarchy.value];
        let constructUrlParameters = exportParameters;
        constructUrlParameters.selectedFramework = selectedFramework
          ? selectedFramework.value
          : selectedFramework;
        constructUrlParameters.selectedCubeHierarchies =
          arrayWithSelectedCubeHierarchyId;

        exportUrl = this.constructUrl(constructUrlParameters);
        let prefixFileName = cubeHierarchy.label;
        if (selectedRelease) {
          prefixFileName += "-" + selectedRelease.releaseType + "-" + selectedRelease.releaseName;
        }
        const fileName = this.generateFileName(prefixFileName, fileFormatForExport);
        this.sendExportRequest(exportUrl, fileName, fileFormatForExport);
      });
    } else {
      let constructUrlParameters = exportParameters;
      constructUrlParameters.selectedFramework = selectedFramework
        ? selectedFramework.value
        : selectedFramework;
      exportUrl = this.constructUrl(constructUrlParameters);

      let fileNamePrefix;
      switch (selectedExportSubFunction) {
        case ExportSubFunction.FRAMEWORKS_EXPORT:
          if (selectedFrameworks.length === 1) {
            fileNamePrefix = selectedFramework.label;
          } else if (selectedFrameworks.length > 1) {
            fileNamePrefix = "multi-framework-export";
          }
          break;
        case ExportSubFunction.INDIVIDUAL_CUBE_EXPORT:
          fileNamePrefix = "individual-cube";
          break;
        case ExportSubFunction.INDIVIDUAL_CUBE_VIEW_EXPORT:
          fileNamePrefix = selectedCubes.name;
          break;
        case ExportSubFunction.INDIVIDUAL_VARIABLE_EXPORT:
          fileNamePrefix = selectedVariable.name;
          break;
        case ExportSubFunction.FRAMEWORK_LOGICAL_LINEAGE:
          fileNamePrefix = "framework-logical-lineage";
          break;
        case ExportSubFunction.FRAMEWORK_MODELS_OVERVIEW:
          fileNamePrefix = "framework-models-overview";
          break;
        default:
          fileNamePrefix = "entities";
          break;
      }
      if (selectedRelease) {
        fileNamePrefix += "-" + selectedRelease.releaseType + "-" + selectedRelease.releaseName
      }
      const fileName = this.generateFileName(fileNamePrefix, fileFormatForExport);
      this.sendExportRequest(exportUrl, fileName, fileFormatForExport);
    }
  };

  figureOutFileFormat = (fileFormat) => {
    if(fileFormat === "csv"){
      return "zip";
    }
    return fileFormat;
  }
}

export default Exporter;
